import {
  Box,
  Flex,
  Heading,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { mainBlockStyle } from "../../styles/common.css";
import { isAfter } from "date-fns";

const INSURANCE_DATA = {
  Model_3: [
    {
      title: "車體損失保險乙式",
      amount: "依車種殘值計算",
      self: "NT$100,000",
      subTitle: "財產損失保險金",
    },
    {
      title: "汽車竊盜損保險",
      amount: "依車種殘值計算",
      self: "依車種10%",
      subTitle: "財產損失保險金",
    },
    {
      title: "第三人傷害責任險",
      amount: "每一個人傷害2,000,000/每一意外事故之傷害4,000,000",
      self: "NT$100,000",
      subTitle: "責任保險金",
    },
    {
      title: "第三人財損責任險",
      amount: "每一意外事故之財損400,000",
      self: "NT$100,000",
      subTitle: "責任保險金",
    },
    {
      title: "乘客體傷責任附加條款",
      amount: "每一人傷害3,000,000/每一意外事故之傷害12,000,000",
      self: null,
      subTitle: "責任保險金",
    },
    {
      title: "第三人責任附加駕駛人傷害險",
      amount: "住院醫療日額2,000/身故失能3,000,000",
      self: "NT$100,000",
      subTitle: "傷害保險金",
    },
    {
      title: "律師費用補償附加條款",
      amount: "NT$300,000",
      self: "NT$300,000",
      subTitle: "費用補償保險金",
    },
    {
      title: "慰問保險金附加條款",
      amount:
        "每一人住院慰問金50,000/每一事故住院慰問金100,000/每一人身故慰問金100,000/每一事故生故慰問金200,000",
      self: null,
      subTitle: "第三人體傷死亡慰問金",
    },
    {
      title: "汽車超額責任險保障型",
      amount: "3,000,000",
      self: null,
      subTitle: "責任保險金",
    },
    {
      title: "道路救援費用附加條款(拖吊里程100公里)",
      amount: "每一事故30,000/保險期間150,000",
      self: null,
      subTitle: "道路救援費用給付",
    },
  ],
  Model_3_LR: [
    { title: "車體損失乙式保險", amount: "2,013,000", self: "100,000" },
    { title: "竊盜損失保險", amount: "2,013,000", self: "10%" },
    {
      title: "第三人責任保險-體傷",
      amount: "2,000,000/40,000,000",
      self: null,
    },
    { title: "第三人責任保險-財損", amount: "400,000", self: null },
    {
      title: "乘客體傷責任附加條款",
      amount: "3,000,000/12,000,000",
      self: null,
    },
    {
      title: "第三人責任附加駕駛人傷害險",
      amount: "2,000/3,000,000",
      self: null,
    },
    { title: "慰問保險金-住院", amount: "50,000/100,000", self: null },
    { title: "慰問保險金-身故", amount: " 100,000/200,000", self: null },
    {
      title: "駕駛人傷害保險 / 乘客責任保險 / 超額責任險",
      amount: "3,000,000",
      self: null,
    },
    { title: "道路救援 (100KM/DAY)", amount: "30,000", self: null },
  ],
  Model_X_75D_灰色: [
    { title: "車體損失乙式保險", amount: "1,573,000", self: "100,000" },
    { title: "竊盜損失保險", amount: "1,573,000", self: "10%" },
    {
      title: "第三人責任保險-體傷",
      amount: "2,000,000/40,000,000",
      self: null,
    },
    { title: "第三人責任保險-財損", amount: "400,000", self: null },
    {
      title: "乘客體傷責任附加條款",
      amount: "3,000,000/15,000,000",
      self: null,
    },
    {
      title: "第三人責任附加駕駛人傷害險",
      amount: "3,000,000/2,000",
      self: null,
    },
    { title: "慰問保險金-住院", amount: "50,000/100,000", self: null },
    { title: "慰問保險金-身故", amount: " 100,000/200,000", self: null },
    {
      title: "駕駛人傷害保險 / 乘客責任保險 / 超額責任險",
      amount: "3,000,000",
      self: null,
    },
    { title: "道路救援 (100KM/DAY)", amount: "30,000", self: null },
  ],
  Model_X_75D_白色: [
    { title: "車體損失乙式保險", amount: "952,000", self: "100,000" },
    { title: "竊盜損失保險", amount: "952,000", self: "10%" },
    {
      title: "第三人責任保險-體傷",
      amount: "2,000,000/40,000,000",
      self: null,
    },
    { title: "第三人責任保險-財損", amount: "400,000", self: null },
    {
      title: "乘客體傷責任附加條款",
      amount: "3,000,000/15,000,000",
      self: null,
    },
    {
      title: "第三人責任附加駕駛人傷害險",
      amount: "3,000,000/2,000",
      self: null,
    },
    { title: "慰問保險金-住院", amount: "50,000/100,000", self: null },
    { title: "慰問保險金-身故", amount: " 100,000/200,000", self: null },
    {
      title: "駕駛人傷害保險 / 乘客責任保險 / 超額責任險",
      amount: "3,000,000",
      self: null,
    },
    { title: "道路救援 (100KM/DAY)", amount: "30,000", self: null },
  ],
};

const InsuranceTable = ({ items }) => {
  return (
    <Table
      variant="simple"
      style={{ tableLayout: "fixed" }}
      border="2px solid black"
    >
      <Thead bg="black">
        <Tr>
          <Th
            color="white"
            textAlign="center"
            w={{ base: "80px", md: "auto" }}
            p={{ base: "5px", md: "15px" }}
          >
            保險種類及名稱
          </Th>
          <Th color="white" textAlign="center">
            主要給付項目
          </Th>
          <Th
            color="white"
            textAlign="center"
            w={{ base: "80px", md: "auto" }}
            p={{ base: "5px", md: "15px" }}
          >
            保險金額
          </Th>
          {/* <Th
            color="white"
            textAlign="center"
            w={{ base: "80px", md: "auto" }}
            p={{ base: "5px", md: "15px" }}
          >
            自負額
          </Th> */}
        </Tr>
      </Thead>
      <Tbody>
        {items.map(({ title, amount, self, subTitle }) => (
          <Tr
            key={title}
            _hover={{
              background: "gray.100",
            }}
          >
            <Td
              textAlign="start"
              fontSize={{ base: "13px", md: "15px" }}
              p={{ base: "5px", md: "15px" }}
            >
              ✅ {title}
            </Td>
            <Td
              textAlign="center"
              fontSize={{ base: "13px", md: "15px" }}
              p={{ base: "5px", md: "15px" }}
            >
              {subTitle}
            </Td>
            <Td
              textAlign="center"
              fontSize={{ base: "13px", md: "15px" }}
              p={{ base: "5px", md: "15px" }}
            >
              {amount}
            </Td>
            {/* <Td
              textAlign="center"
              fontSize={{ base: "13px", md: "15px" }}
              p={{ base: "5px", md: "15px" }}
            >
              {self || "無"}
            </Td> */}
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

const TableRow = ({ item }) => {
  return (
    <Tr
      _hover={{
        background: "gray.100",
      }}
    >
      <Td
        textAlign="center"
        fontSize={{ base: "13px", md: "15px" }}
        p={{ base: "5px", md: "15px" }}
      >
        {item.title}
      </Td>
      <Td
        textAlign="center"
        fontSize={{ base: "13px", md: "15px" }}
        p={{ base: "5px", md: "15px" }}
      >
        {item.price}
      </Td>
    </Tr>
  );
};

const Title = ({ text, ...props }) => {
  return (
    <Heading
      fontSize="24px"
      backgroundColor="#333"
      display="inline-block"
      color="#fff"
      px="15px"
      py="10px"
      borderRadius="15px"
      boxShadow="0 10px 25px 0 rgba(0, 0, 0, .25)"
      my="20px"
      align="left"
      id={text}
      {...props}
    >
      {text}
    </Heading>
  );
};

function Info() {
  return (
    <>
      <Head>
        <title key="title">政策與保險｜特斯拉 Tesla 出租｜悠駕 UDRIVE</title>
        <meta
          key="description"
          name="description"
          content="Tesla 特斯拉電動車出租車最低價，租車特斯拉多天方案更優惠"
        />
        <meta
          key="og_title"
          property="og:title"
          content="政策與保險｜特斯拉 Tesla 出租｜悠駕 UDRIVE"
        />
        <meta
          key="og_description"
          property="og:description"
          content="Tesla 特斯拉電動車出租車最低價，租車特斯拉多天方案更優惠"
        />
        <meta
          key="og_image"
          property="og:image"
          content="https://www.udrive.city/share.jpg"
        />
        <meta
          key="og_url"
          property="og:url"
          content="https://www.udrive.city/info"
        />
      </Head>
      <Flex
        id="info"
        justify="center"
        direction="column"
        align="center"
        maxW="800px"
        mx="auto"
        w="95%"
      >
        <Heading textAlign="center" my="0px" display="flex">
          <a href="#租借政策">
            <Text
              color="#0066CC"
              mr="15px"
              textDecor="underline"
              cursor="pointer"
            >
              租車政策
            </Text>
          </a>
          與
          <a href="#租車保險">
            <Text
              color="#0066CC"
              ml="15px"
              textDecor="underline"
              cursor="pointer"
            >
              租車保險
            </Text>
          </a>
        </Heading>

        <Heading
          textAlign="center"
          my="0px"
          display="flex"
          onClick={() => {
            window.open("https://www.udrive.city/blog/4624", "_blank");
          }}
        >
          <Text
            color="#0066CC"
            ml="15px"
            textDecor="underline"
            cursor="pointer"
          >
            悠駕平台政策與保險
          </Text>
        </Heading>

        {/* 租車政策 */}
        <Flex
          justify="center"
          align="center"
          direction="column"
          mb="32px"
          mt="10px"
          w="100%"
        >
          <VStack justify="left" align="left" spacing="20px" px="20px">
            <Title text="租借政策" mb="0px" id="租借政策" />
            <Box>
              <Text>
                甲方為:悠勢科技股份有限公司悠駕租賃營業所
                <br />
                乙方為:承租人
              </Text>
              <Heading size="md" mb="5px" mt="10px">
                駕駛員（承租人）資格
              </Heading>
              <Text mb="8px">如未符合以下規定，本平台有權終止租賃契約。</Text>
              <Heading size="sm" mb="5px">
                帳戶要求
              </Heading>
              <Text mb="8px">
                您必須為本平台USPACE（同UDRIVE）之註冊會員，若您尚未註冊，請輸入您的手機號碼註冊後再行下訂。
              </Text>

              <Heading size="sm" mb="5px">
                年齡要求
              </Heading>
              <Text mb="8px">您的年齡需介於 20 歲 （含）~ 75 歲（含）。</Text>

              <Heading size="sm" mb="5px">
                證件要求
              </Heading>
              <Text mb="8px">
                下訂時會需要您先上傳相關證件至官網以供審核，若需補件會通知您
              </Text>
              <Text fontWeight="700">本國國民</Text>
              <Text>
                您必須持有臺灣監理機關認可之有效汽車駕照滿 2 年以上，若未滿 2
                年則須在每次租車行程開始前自行加保國內旅遊險（需含汽車駕駛人車體損失責任保額至少NT$
                10萬）或租借車保險（需含車體損失責任保額至少NT$
                10萬），並於下訂後提供相關投保證明給本平台客服確認。如未符合以上規定，則本平台有權終止訂單交易。
                <br />
                取車時也須請您出示下訂時上傳之中華民國身份證及駕照以便進行核對。若取車時未能出示相同證件，本平台恕無法交車給您，且費用概不退還。
              </Text>

              <Text fontWeight="700">非本國國民</Text>
              <Text>
                您必須持有合法且有效之護照及國際駕照。詳細證件說明請諮詢客服。
                <br />
                取車時務必攜帶護照及國際駕照以便進行核對。若取車時未能出示相同證件，本平台恕無法交車給您，且費用概不退還。
              </Text>
            </Box>
            <Box>
              <Heading size="md" mb="5px">
                押金收取及退還
              </Heading>

              <Text>
                （一）下訂時會向您額外收取 NT$ 10,000
                押金。若下訂日距離取車時間大於 3
                天，下訂時不會直接扣款，押金將於交車前 3 日自動扣款。
              </Text>
              <Text>
                （二）若產生ETC過路費，本平台將於還車後 7
                個工作日內確認金額後線上扣款，確認收到金額後押金將全數退還。
                若發生車損，您將維修費及營業損失金支付給本平台（或指定維修廠）後，押金方全數退還。
              </Text>
              <Text>
                （三）本平台會於歸還車況確認無誤後10
                個工作天內進行退還押金流程，藍新金流會在 7
                個工作日內，將金額退還至原信用卡。具體退款時間及退款進度，請向信用卡發卡公司確認。
              </Text>
            </Box>
            <Box>
              <Heading size="md" mb="5px">
                取還車說明及規範
              </Heading>

              <Text>
                （一）免費里程：每租滿 24 小時送 300 公里，可累計。超過則每 1
                公里加收 NT$ 5 里程費。
              </Text>
              <Text>
                （二）充電費及電池維護費：使用者付費（詳細說明請見下方電量政策）。
                本平台提供電量 85% ± 5%
                之車輛供您承租，還車時將依下表向您酌收電池維護費：
              </Text>
              <Box pl="20px">
                {/* 2026/03/02 開始調整費率 */}
                {isAfter(new Date(), new Date("2026/03/02")) ? (
                  <>
                    <Text>
                      1. 0% ~ 5%：NT$
                      6000（含拖吊費用，為避免車輛無法行駛，務必請您注意電量）。
                    </Text>
                    <Text>2. 6% ~ 20%：NT$ 5000</Text>
                    <Text>3. 21% ~ 50%：NT$ 3000</Text>
                    <Text>4. 51% ~ 80%：NT$ 450</Text>
                    <Text>5. 81% ~ 100%：NT$ 0</Text>
                  </>
                ) : (
                  <>
                    <Text>
                      1. 0% ~ 5%：NT$
                      5000（含拖吊費用，為避免車輛無法行駛，務必請您注意電量）。
                    </Text>
                    <Text>2. 6% ~ 20%：NT$ 1000</Text>
                    <Text>3. 21% ~ 50%：NT$ 750</Text>
                    <Text>4. 51% ~ 80%：NT$ 450</Text>
                    <Text>5. 81% ~ 100%：NT$ 0</Text>
                  </>
                )}
              </Box>

              <Text>
                （三）為確保行車安全，所有車款均有設定限速，不可解除。
              </Text>
            </Box>
            <Box
              p="20px"
              borderRadius="15px"
              backgroundColor="#F1F1F1"
              my="15px"
            >
              <Heading size="md" mb="5px">
                取車
              </Heading>
              <Text>
                （一）您應依您下訂的指定取車時間準時至指定地點與車主取車，且您必須參與取車時
                15 ~ 20分鐘之車輛操作教學。
              </Text>
              <Text>
                （二）若您欲提前取車，應大於約定取車日 1
                日前通知本平台。契約起始時間則依雙方協議之時間重新計算，並將向您收取額外租賃費用。若您未提前通知，本平台得依實際情況拒絕您的要求，且您不得依此主張取消訂單。
                <br />
                若您欲遲延取車，應大於約定租車日1
                日前通知本平台客服，並取得本平台同意後方得遲延取車。注意，遲延取車期間仍依您原訂單之租賃契約計算租賃費用，將不會退款給您。若您未事前取得同意遲延取車超過
                30 分鐘者，車主得直接離開。您應於約定之取車時間起 2
                小時內，另行約定時間及地點取車。
                <br />
                若您遲延取車超過 2
                小時者，本平台將為您取消訂單，且費用恕不退還，請您見諒。
              </Text>
              <Text>
                （三）取車時務必攜帶下訂時於官網上傳的相同證件以供審查。
              </Text>
              <Heading size="md" mb="5px" mt="10px">
                還車
              </Heading>
              <Text>
                （一）若您欲提前還車，或因可歸因於您之情事而由本平台提前終止契約者，您不得請求退還未使用時數之租賃費用。
              </Text>
              <Text>
                （二）若您逾時還車，將向您另收超時租金及調度費。費用說明如下：
              </Text>
              <Heading size="sm" my="5px">
                超時租金
              </Heading>
              <Text>
                逾時還車逾 1 小時者（滿 30分鐘未滿 1 小時者以 1 小時計），每滿 1
                小時按當日租金十分之一計算收費。
              </Text>
              <Text>
                逾時還車累計每滿 6 小時者，以當日之 1
                日租金計算收費。將於您還車時確認費用，線上刷卡扣款。
              </Text>

              <Heading size="sm" my="5px">
                調度費
              </Heading>
              <Text>
                若您於還車前 12
                小時內告知需變更還車時間或地址，需向您額外收取調度費 NT$ 500
                整。若您於還車前 4
                小時內告知需變更還車時間或地址，需向您額外收取調度費 NT$ 1,000
                整。
              </Text>
              <Text>
                此費用將於您提出需求後即進行線上刷卡付款。注意，調度費並不包含超時租金。
              </Text>
            </Box>
            <Box>
              <Heading size="md" mb="5px">
                取消政策
              </Heading>

              <Text>
                因可歸責於您之事由致不能履行時，本平台將按您提出取消時間與預定租車到達時間之差，依下列規定計算退還定金（全額租金之
                30%）：
              </Text>

              <Box ml="10px">
                <Text>
                  1. 您於預定租車時間 10
                  日前（按小時算）通知取消，本平台將退還全額定金。
                </Text>
                <Text>
                  2. 您於預定租車時間 7 ~ 9
                  日前（按小時算）通知取消，本平台將退還 50% 定金。
                </Text>
                <Text>
                  3. 您於預定租車時間 4 ~ 6
                  日前（按小時算）通知取消，本平台將退還 40% 定金。
                </Text>
                <Text>
                  4. 您於預定租車時間 2 ~ 3
                  日前（按小時算）通知取消，本平台將退還 30% 定金。
                </Text>
                <Text>
                  5. 您於預定租車時間1日前（按小時算）通知取消，本平台將退還 20%
                  定金。
                </Text>
                <Text>
                  6.
                  您於預定租車時間不及1日前（按小時算）通知取消或怠於通知，恕本平台概不退還全額定金。
                </Text>
              </Box>

              <Heading size="sm" mt="10px">
                費用退還
              </Heading>
              <Text>
                本平台將在您提出取消後以信用卡刷退方式退還定金，請您自行負擔刷退信用卡之手續費。注意，本平台操作退款程序後藍新金流會在
                7
                個工作日內，將刷定金額退還至原信用卡。具體退款時間及退款進度，請您向信用卡發卡公司確認。
              </Text>

              <Text>
                如遇天災、地變或其他因不可歸責於雙方當事人之事由致不能屢行時，本平台將返還全額定金。
              </Text>
            </Box>
            <Box>
              <Heading size="md" mb="5px">
                清潔政策
              </Heading>
              <Text>
                為確保每一位租車客戶都能享受到乾淨、舒適且安全的租車體驗，本平台致力於提供乾淨整潔無異味之車輛，並於交車時特別提醒需避免在車內飲食或攜帶寵物上車，因此還車時請您確保與取車時一致。對於租賃期間未能遵守規範者，如有異味或髒污，包含且不限於寵物毛髮、飲料、食物、藥品、藥劑、菸味或其他任何方式產生之污漬，我們將向您收取
                NT$ 5000
                清潔及懲罰性費用（包含清潔所需的人工和物料成本、因清潔車輛而無法出租的營業損失費等），敬請您務必注意。若清除前述污漬所需之費用超過
                NT$ 5000 ，本平台將依照實際費用向您收取。
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb="5px">
                電量政策
              </Heading>
              <Text>（一）充電費</Text>
              <Text>
                若您使用特斯拉超級充電服務，則超充費用將於訂單完成後統一向您收款，包括衍生費用：
              </Text>
              <Box pl="20px">
                <Box display="inline">
                  超時佔用費：當您的車輛已經完成充電（無論設定滿電為幾%，只要到達設定的%數即算充電完成），且您在完成充電後
                  5 分鐘內沒離開時，特斯拉系統將自動計算佔用費。詳細說明請參考
                </Box>
                <Box
                  display="inline"
                  color="#0066CC"
                  cursor="pointer"
                  onClick={() =>
                    window.open(
                      "https://www.tesla.com/zh_tw/support/charging/supercharger",
                      "_blank",
                    )
                  }
                >
                  TESLA 官網
                </Box>
                <Box display="inline">。</Box>
              </Box>
              <Text>
                其餘用車期間之充電費用，須請您依據各家充電樁業者收費方式自行支付。
              </Text>

              <Text>（二）電量政策</Text>
              <Text>
                本平台提供電量 85 % ± 5 %
                之車輛供您承租，還車時將依下表向您酌收電池維護費：
              </Text>
              <Box pl="20px">
                {isAfter(new Date(), new Date("2026/03/02")) ? (
                  <>
                    <Text>
                      1. 0% ~ 5%：NT$
                      6000（含拖吊費用，為避免車輛無法行駛，務必請您注意電量）。
                    </Text>
                    <Text>2. 6% ~ 20%：NT$ 5000</Text>
                    <Text>3. 21% ~ 50%：NT$ 3000</Text>
                    <Text>4. 51% ~ 80%：NT$ 450</Text>
                    <Text>5. 81% ~ 100%：NT$ 0</Text>
                  </>
                ) : (
                  <>
                    <Text>
                      1. 0% ~ 5%：NT$
                      5000（含拖吊費用，為避免車輛無法行駛，務必請您注意電量）。
                    </Text>
                    <Text>2. 6% ~ 20%：NT$ 1000</Text>
                    <Text>3. 21% ~ 50%：NT$ 750</Text>
                    <Text>4. 51% ~ 80%：NT$ 450</Text>
                    <Text>5. 81% ~ 100%：NT$ 0</Text>
                  </>
                )}
              </Box>
              <Text>
                充電地圖：建議您下載 USPACE APP，以享受更好的使用體驗。
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb="5px">
                事故與車損
              </Heading>
              <Text>
                （一）若您於租用車輛期間發生擦撞、毀損、翻覆、失竊、故障、拋錨或其他意外事故，請您立即向警憲單位報案取得事故登記聯單並通知本平台及車主，且需將車輛送至本平台指定之廠商修復（若有拖車費用的產生須由您負擔）。您須給付維修費用，且同意維修費用依本平台指定廠商之估價為準。
              </Text>
              <Text>
                （二）若您未經本平台同意擅自修復租用車輛或是於非指定之維修廠修復，本平台仍得將租用車輛送回指定廠商重新估價、維修，除向您收取維修費用外，本平台得要求您賠償懲罰性違約金
                NT$ 200,000，若造成其他部件損害，您亦須負損害賠償責任。
              </Text>
              <Text>
                （三）若因非承租人或非共同承租人為駕駛人之事故、違反租賃合約規範包括但不限於酗酒、不明車損、自然災害等保險不理賠之行為、事故無取得受(處)理案件證明單或私下與第三方和解造成任何損失亦由您全數負賠償之責。
              </Text>
              <Text>
                （四）未經本平台同意者，您不得私下與肇事對方達成和解。
              </Text>
              <Text>
                （五）當事故發生後，若車輛行駛有危險之虞，請您立即與本平台聯繫，不得將車輛棄置於無人看管之場所。
              </Text>
              <Text>
                （六）若因您怠於通知或違反本條約定，導致本平台喪失保險理賠權益時，所有損害需由您全數負賠償之責。
              </Text>
              <Text>
                （七）營業損失費用
                <br />
                車輛維修期間，您應依下列規定賠償本平台營業損失：
              </Text>
              <Box ml="20px">
                <Text>
                  1.修理期間在 10 日以內者，您應償付該期間 70% 之原價租金。
                </Text>
                <Text>
                  2.在 11 日以上 15日以內者，您應償付該期間 60% 之原價租金。
                </Text>
                <Text>3. 在 16 日以上者，您應償付該期間 50% 之原價租金。</Text>
                <Text>4. 修復期間最長以 20 日為限。</Text>
              </Box>

              <Text>
                （八）營業損失押金
                <br />
                租賃期間如發生車輛損壞，本平台於還車時將以您下訂時提供之信用卡資訊，預刷營業損失押金
                NT$
                20,000，收到您支付的維修費及營業損失費後將即刻退還此筆預刷押金費用，敬請特別注意。
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb="5px">
                車輛使用注意事項
              </Heading>
              <Text>
                乙方若違反下列條款，甲方得立即終止租賃契約並即時收回車輛，如另有損害得向乙方請求賠償：
              </Text>

              <Heading size="sm" mt="10px">
                承租遵守事項
              </Heading>
              <Box ml="10px">
                <Text>
                  1.
                  乙方應盡善良管理人注意義務保管及維護租用車輛，禁止將租用車輛出賣、設質、抵押、讓與擔保、典當等行為。
                </Text>
                <Text>
                  2.
                  租賃期間乙方應隨車攜帶駕駛執照、強制汽車責任保險證、汽車出租單及行車執照以備查驗。
                </Text>
                <Text>
                  3.
                  乙方保證未以詐欺或為委虛偽陳述之方法（包括但不限於：冒名或以虛偽身份、資格）向甲方註冊會員，或與甲方成立任何契約。
                </Text>
                <Text>
                  4. 乙方保證簽訂本契約時乙方擁有中華⺠國合格且有效之駕駛資格。
                </Text>
                <Text>
                  5.
                  乙方承諾使用租用車輛時遵守下列行為，乙方若有本項約定，甲方立即終止租賃契約，並即時收回車輛，如另有損害並得向乙方請求賠償。
                </Text>
                <Box ml="10px">
                  <Text>5.1 不得超載。</Text>
                  <Text>5.2 不得乘載違禁品及危險品。</Text>
                  <Text>5.3 不得乘載不潔或易於汙損車輛之物品。</Text>
                  <Text>5.4 不得乘載不適宜隨車之全部動物類。</Text>
                  <Text>
                    5.5
                    乙方應在約定範圍內使用車輛並自行駕駛，不得將租用車輛交予無駕照之第三人駕駛。
                  </Text>
                  <Text>
                    5.6 乙方不得以租用車輛從事汽車運輸業行為或充作教練車等用途。
                  </Text>
                  <Text>
                    5.7
                    乙方不得以租用車輛為收取明示或默示之報酬而攬載乘客或貨物。
                  </Text>
                  <Text>5.8 乙方不得以租用車輛於路上蛇行。</Text>
                  <Text>
                    5.9
                    乙方駕駛租用車輛之行車速度，不得超過規定之最高時速40公里以上。
                  </Text>
                  <Text>
                    5.10 乙方不得拆除租用車輛之消音器，或以其他方式造成噪音。
                  </Text>

                  <Text>
                    5.11
                    乙方不得酒駕或於吸食、服用麻醉藥品、迷幻藥物、毒品及其他相類似之管制藥品後駕車。
                  </Text>
                  <Text>
                    5.12 乙方不得以租用車輛推動或拖曳任何其他車輛及物體。
                  </Text>
                  <Text>
                    5.13 乙方不得以租用車輛參與任何競賽或其他試驗性目的之活動。
                  </Text>
                  <Text>
                    5.14
                    使用租用車輛時乙方應確保自己及所有乘客不得於租用車輛內吸菸。
                  </Text>
                  <Text>
                    5.15
                    乙方不得以租用車輛為任何違反中華⺠國法令或其他違法目的之使用。
                  </Text>
                </Box>
                <Text>
                  6. 乙方如有違反本條第一、三、四、五項之約定，應給付甲方 NT$
                  200,000 懲罰性違約金；若因此造成其他損害者，負損害賠償責任。
                </Text>
              </Box>
            </Box>

            <Box>
              <Heading size="md" mb="5px">
                其他條款
              </Heading>
              <Text>
                （一）承租人因酗酒駕車、犯罪行為、逃避合法拘捕、吸食禁藥、故意行為、轉介於無照駕駛人或違約行為致使車輛損壞、需由承租人負全部賠償責任，不受車損最高自負額限制。
              </Text>
              <Text>
                （二）凡行車速度超過規定之最高時速 40
                公里以上競速飆車或在道路蛇行者，依法處新台幣三萬元以上九萬元以下罰鍰，並得吊扣汽車牌照
                6
                個月。若乙方具上述違規行為，除罰單金額由承租人負擔外，另就車牌吊扣致本公司營業損失部分，亦由乙方負擔。車輛若有瑕疵或操作不良時，請立即回報，否則仍將負擔租金費用。
              </Text>
              <Text>
                （三）輪胎單獨破損爆胎或無氣時，請依狀況立即停駛，就近尋找維修廠修復或聯繫道路救援服務處理，否則造成車胎無法修補或其他機零件損壞，乙方需自行負擔賠償事宜。
              </Text>
              <Text>
                （四）非承租人駕駛者，駕駛人及乙方須負聯帶損害賠償責任，甲方並得取消乙方會員資格。
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb="5px">
                車輛損害、遺失或被盜
              </Heading>

              <Text>
                （一）當車輛損傷時，您必須賠償車輛修復費用，車體損失賠償最高以
                NT$ 100,000
                為限，若有酒駕、違反租賃契約之規定、或是保險不予理賠之行為及非保險承保範圍之事故者，您仍須負全數賠償責任。
              </Text>
              <Text>
                （二）租用車輛有遺失或遭竊、盜者，乙方應立即報案並通知甲方。
              </Text>
              <Text>
                （三）租用車輛遺失或遭竊、盜者，乙方應照當時市價賠償，如有投保竊盜損失保險者，乙方得僅支付市價與保險賠償金額之差額。
              </Text>
              <Text>
                （四）乙方應持續給付甲方租用車輛之單日原價租金，直至租用車輛尋獲交還甲方或乙方完成前項規定之賠付。
              </Text>
              <Text>
                （五）乙方已賠償後，失竊車輛經尋獲者，如本車輛未投保竊盜損失保險者，甲方應即將租用車輛過戶予乙方。
              </Text>
            </Box>

            <Box>
              <Heading size="md" mb="5px">
                設備遺失、損壞
              </Heading>
              <Text>
                歸還租用車輛時，請確保車輛所提供之配備保存完整且無遺失，若配備產生損壞或遺失，將按下表價格向您收取賠償費用：
              </Text>

              <Table
                variant="simple"
                style={{ tableLayout: "fixed" }}
                border="2px solid black"
              >
                <Thead bg="black">
                  <Tr>
                    <Th
                      color="white"
                      textAlign="center"
                      w={{ base: "80px", md: "auto" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      項目
                    </Th>
                    <Th
                      color="white"
                      textAlign="center"
                      w={{ base: "80px", md: "auto" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      收費標準
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      慢充轉接頭
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      3,000 元
                    </Td>
                  </Tr>
                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      USB 隨身碟
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      1,300 元
                    </Td>
                  </Tr>
                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      螢幕保護貼
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      500元
                    </Td>
                  </Tr>

                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      防水腳踏墊
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      800 元/片
                    </Td>
                  </Tr>
                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      天窗遮陽板
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      1,300 元
                    </Td>
                  </Tr>
                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      品牌雨傘
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      500元
                    </Td>
                  </Tr>
                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      兒童安全座椅
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      8,500 元
                    </Td>
                  </Tr>
                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      原廠救援包
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      5,500 元
                    </Td>
                  </Tr>
                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      隔熱紙
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      依廠商報價
                    </Td>
                  </Tr>
                  <Tr
                    _hover={{
                      background: "gray.100",
                    }}
                  >
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      車內其他原廠設備
                    </Td>
                    <Td
                      textAlign="center"
                      fontSize={{ base: "13px", md: "15px" }}
                      p={{ base: "5px", md: "15px" }}
                    >
                      依廠商報價
                    </Td>
                  </Tr>
                </Tbody>
              </Table>
            </Box>
          </VStack>
        </Flex>

        {/* 租車保險 */}
        <Flex
          id="租車保險"
          justify="center"
          direction="column"
          px="10px"
          w="100%"
        >
          <Title text="租車保險" />
          <Text
            fontWeight="600"
            color="#0066CC"
            ml="15px"
            textDecor="underline"
            cursor="pointer"
            onClick={() => {
              window.open("https://www.udrive.city/blog/1067-insurance");
            }}
          >
            點我閱讀懶人包
          </Text>
          <Text my="5px">除強制汽車責任險外，本契約之租金附加下列保險：</Text>
          {Object.keys(INSURANCE_DATA)
            .slice(0, 1)
            .map((car) => {
              const items = INSURANCE_DATA[car];
              return (
                <Box mb="40px" key={car} id={`行車保險_${car}`}>
                  {/* <Text fontSize="30px" fontWeight="600" mb="10px">
                {car.replace(/_/g, " ")}
              </Text> */}
                  <InsuranceTable items={items} />
                  {/* <Text mt="20px" fontSize="14px">
                    ＊若車輛維修或失竊期間，承租人另須負擔無法營業之損失費用。營業損失費用負擔上限為
                    20 日 (營業損失收取須依該出租車輛原價租金額計算)。
                  </Text> */}
                  <Text mt="5px">
                    （一）上述保險於保險契約中約定之自負額（竊盜損失險自負額百分之十、第三人傷害責任險自負額100,000元、第三人財損責任險自負額100,000元）由承租人自行負擔。
                  </Text>
                  <Text mt="10px">
                    （二）前兩項保險不包括因自然災害（洪水、颱風、地震等）造成之損傷及車內配備（螢幕、音響、車窗等）之遺失或損壞之賠償責任。
                  </Text>
                  <Text mt="5px">
                    （三）若因可歸責於承租人之事由導致其應負責賠償損失之金額超過上述標準上限及範圍者（包含但不限於財損、精神工作損失等），由承租人自行負擔，與出租人無涉。
                  </Text>
                </Box>
              );
            })}
        </Flex>

        <Flex
          justify="center"
          align="left"
          direction="column"
          my="32px"
          w="100%"
        >
          <Title text="其他相關細項" />
          <Text>
            若您未透過本平台下訂或經由其他第三人租借本平台所有之車輛，則保險範圍內，若事故發生保險無法理賠，切勿私下進行租借。
          </Text>

          <Text>
            信用卡授權
            <br />
            需先請您綁定付款信用卡，以支付各項費用，包含但不限於押金、租金、延長租金、超時租金、充電費、超時佔用費、清潔費、營業損失、損害賠償、行政規費等費用。綁卡時本平台將使用3D驗證來確認持卡人身份，敬請安心。
          </Text>

          <Flex w="100%" justify="end" mt="25px" mb="100px" px="10px">
            <Text>20240923版</Text>
          </Flex>
        </Flex>
      </Flex>
    </>
  );
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}

export default Info;
